import React, {useState} from 'react';
import {toast} from "react-toastify";
import ModalContainer from "../../../../components/ModalContainer";
import Input from "../../../../components/common/Input";
import Button from "../../../../components/common/Button";
import TextButton from "../../../../components/common/TextButton";
import CompanyObserver from "../../../../mobx/company/CompanyObserver";
import FetchService from "../../../../services/api/FetchService";
import {ErrorToastSettings} from "../../../../services/toast/toastSettings";
import styles from './styles.module.scss';

interface IProps {
    handleClose: () => void;
    handleUploaded: () => void;
}

const UploadChecklistModal: React.FC<IProps> = ({handleClose, handleUploaded}) => {
    const [name, setName] = useState<string>('');
    const [file, setFile] = useState<File | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const handleChangeFile = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFile(e.target.files?.[0] ?? null);
    };

    const isValid = name.trim() !== '' && file !== null;

    const handleUpload = async () => {
        const companyId = CompanyObserver.getCompanyId();
        if (!companyId || !file || !isValid) return;

        const formData = new FormData();
        formData.append('name', name);
        formData.append('checklist', file);

        try {
            setIsLoading(true);
            await FetchService.postChecklistManagementUpload(companyId, formData);
            handleUploaded();
        } catch (error) {
            toast.error('Не вдалося завантажити чеклист', ErrorToastSettings);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <ModalContainer handleClose={handleClose}>
            <div className={styles.upload}>
                <h2 className={styles.upload__title}>Завантажити чеклист</h2>
                <Input
                    placeholder={'Назва'}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    disabled={isLoading}
                />
                <label className={styles.upload__label}>
                    Файл (CSV)
                    <input
                        className={styles.upload__file}
                        type={'file'}
                        accept={'.csv,text/csv'}
                        onChange={handleChangeFile}
                        disabled={isLoading}
                    />
                </label>
                <div className={styles.upload__footer}>
                    <TextButton
                        text={'Скасувати'}
                        onClick={handleClose}
                    />
                    <Button
                        text={isLoading ? 'Завантаження...' : 'Завантажити'}
                        onClick={handleUpload}
                        disabled={!isValid || isLoading}
                    />
                </div>
            </div>
        </ModalContainer>
    );
};

export default UploadChecklistModal;
